import { atom } from 'jotai';

export interface DsgvoState {
  showCookieOverlay: boolean;
  performanceCookies: boolean;
  functionalCookies: boolean;
  targetingCookies: boolean;
}

const INITIAL_DSGVO: DsgvoState = {
  showCookieOverlay: true,
  performanceCookies: false,
  functionalCookies: false,
  targetingCookies: false,
};

const STORAGE_KEY = 'rin-dsgvo';

function loadFromStorage(): DsgvoState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // ignore
  }
  return INITIAL_DSGVO;
}

const dsgvoAtom = atom<DsgvoState>(loadFromStorage());

export { dsgvoAtom, INITIAL_DSGVO };
